import moment from 'moment'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { select } from '@/store'

const useGetRenewalContract = listingId => {
  const dispatch = useDispatch()
  const loadEndTenancyData = dispatch.endTenancy.loadAll
  const loadListingContracts = dispatch.contract.getListingContracts

  useEffect(() => {
    loadEndTenancyData({ listingId })
  }, [listingId, loadEndTenancyData])

  useEffect(() => {
    loadListingContracts(listingId)
  }, [listingId, loadListingContracts])

  const nextContract = useSelector(state => select.contract.nextContract(state, { listingId }))

  const lastActiveContract = useSelector(state =>
    select.contract.lastActiveContract(state, { listingId })
  )

  const lastEndDate = nextContract ? nextContract?.end_date : lastActiveContract?.end_date
  const start_date = lastEndDate ? moment(lastEndDate).add(1, 'days').format('YYYY-MM-DD') : null
  const end_date = start_date ? moment(start_date).add(1, 'years').format('YYYY-MM-DD') : null

  const renewalContract = {
    ...(nextContract ? nextContract : lastActiveContract),
    start_date,
    end_date
  }

  return {
    renewalContract,
    nextContract
  }
}

export default useGetRenewalContract
